import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { getServerUrl } from '../utils/utils';

@Injectable()
export class ScattergoriesHostLoginResolver implements Resolve<any> {
  constructor(private httpClient: HttpClient, private cookieService: CookieService) {}

  resolve() {
    let gameId = '';

    if (this.cookieService.check('gameId')) {
      gameId = this.cookieService.get('gameId');
    }

    const serverUrl = getServerUrl('S') + '/verify-game';

    const body = {
      gameId: gameId
    };

    return this.httpClient.request('post', serverUrl, { body });
  }
}
